import React, { forwardRef, useMemo } from 'react';
import PropTypes from 'prop-types';

import TableComponentsContext from '../Table/TableComponentsContext';
import { TableHeadRoot } from './TableHeadStyles';
import { conditionalClassNames } from 'UtilityComponents/Util';

/**
 *
 * @param {Object} classes - {
 * root - Class applied to all TableHead
 * }
 * @param {String} theme - Theme will be provided to child components through Context
 */

const TableHead = ({ classes = {}, theme = 'light', forwardedRef, ...other }) => {
	const { root = '' } = classes;
	const className = conditionalClassNames({
		[root]: root
	});

	const tableComponent = useMemo(() => ({
		variant: 'head',
		theme
	}), [theme]);

	return (
		<TableComponentsContext.Provider value={tableComponent}>
			<TableHeadRoot
				className={className}
				ref={forwardedRef}
				{...other}
			/>
		</TableComponentsContext.Provider>
	);
};

TableHead.propTypes = {
	classes: PropTypes.object,
	theme: PropTypes.oneOf(['light', 'dark'])
};

export default forwardRef((props, ref) => <TableHead {...props} forwardedRef={ref} />);
